import { Component, Mixins, Prop } from "vue-property-decorator";

import { PageMixin } from "@/mixins/pageMixin";

import LocationFull from "@/vuex/models/location/location-full";
import UserProfile from "@/vuex/models/user/user-profile";
import { http } from "@/services/http/http";
import { ActionTypes as NotificationActions } from "@/vuex/modules/notifications-module/action-types";
import { NotificationType } from "@/vuex/modules/notifications-module/state";
import QRCode from "qrcode";

@Component({})
export default class LocationItem extends Mixins(PageMixin) {
  @Prop({
    required: false,
    type: Object,
  })
  public location!: LocationFull;

  public isDownloadButton: boolean = false;
  public qr_code_link: null | string = null;

  protected locationUsers(location: LocationFull): string {
    const users: string[] = location.users.map(
      (user: UserProfile) => `${user.name} ${user.surname}`
    );

    return users.join(", ");
  }

  created() {
    this.isDownloadButton = !!this.location.qr_active;
    this.qr_code_link = this.location?.qr_code_link || null;
  }

  async downloadQrCode() {
    try {
      const qrText = this.qr_code_link ?? "";
      const options = {
        type: "svg",
        errorCorrectionLevel: "H",
        margin: 1,
        width: 1200,
        scale: 1,
      };
      const svgString = await QRCode.toString(qrText, options as any);

      const link = document.createElement("a");
      link.href =
        "data:image/svg+xml;charset=utf-8," +
        encodeURIComponent(svgString as any);
      link.download = "qrcode.svg";
      link.click();
    } catch (error) {
      console.error("Error generating QR code:", error);
    }
  }

  async swithLocationQrCode(isSwitch: boolean, id: number) {
    try {
      const response = await http().put(`/api/locations/qr/${id}`, {
        qr_active: isSwitch ? 1 : 0,
      });
      this.qr_code_link = response?.data?.qr_code_link;
      this.isDownloadButton = isSwitch;
    } catch (exception: any) {
      await this.$store.dispatch(NotificationActions.PUSH_NOTIFICATION, {
        text: exception.response.data.message,
        type: NotificationType.DANGER,
      });
    }
  }
}
